import { Col, Row, Typography } from "antd";
import React from "react";
import styled from "styled-components";
import { ReactComponent as NotFoundIcon } from "../../assets/icons/NotFound.svg";

export enum NotFoundType {
  EMPTY = "존재하지 않는 페이지입니다.",
  NOTFOUND = "잘못된 주소 입니다.",
}
export type NotFoundTypes = keyof typeof NotFoundType;

interface NotFoundProps {
  type?: NotFoundTypes;
}

const NotFound: React.FC<NotFoundProps> = ({ type = "NOTFOUND" }) => {
  return (
    <StyledContainer>
      <Row justify="center" align="middle" wrap>
        <Col span={24} style={{ textAlign: "center" }}>
          <NotFoundIcon />
        </Col>
        <Col span={24} style={{ textAlign: "center" }}>
          <Typography.Title level={3}>{NotFoundType[type]}</Typography.Title>
        </Col>
      </Row>
    </StyledContainer>
  );
};
export default NotFound;
const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  #root > & {
    width: 100vw;
    height: 100vh;
  }
`;
